<div class="add-page">
  <div class="add-page__header">
    <div class="header-link-block">Profile</div>
  </div>
  <div class="add-page__content">
    <div style="width: 50%; height: 5rem;" class="input-container">
      <label style="fontSize: 1.2rem" class="input-label">First Name</label>
      <input
          [(ngModel)]="firstName"
          name="first-name"
          class="add-input"
          type="text"
          />
    </div>
    <div style="width: 50%; height: 5rem;" class="input-container">
      <label style="fontSize: 1.2rem" class="input-label">Last Name</label>
      <input
          [(ngModel)]="lastName"
          name="last-name"
          class="add-input"
          type="text"
          />
    </div>
    <div style="width: 50%; height: 5rem;" class="input-container">
      <label style="fontSize: 1.2rem" class="input-label">Email</label>
      <input
          [(ngModel)]="email"
          name="email"
          class="add-input"
          type="email"
          />
    </div>
    <div style="width: 50%; height: 5rem;" class="input-container">
      <label style="fontSize: 1.2rem" class="input-label">Password</label>
      <input
          [(ngModel)]="password"
          name="password"
          class="add-input"
          type="password"
          />
    </div>
    <div
        [style.grid-template-columns]="'15rem' + ' ' + '!important'"
        class="add-page__buttons"
        >
        <button-cmp
            isLogin="false"
            isAdd="false"
            isCancel="false"
            [title]="update"
            (click)="onUpdateClick()"
            ></button-cmp>
    </div>
  </div>
